import moment from "moment-timezone";
import { timestampSecondsToMoment, endDateNow, getNHoursAgoAsSeconds, getUTCDateWithLocalTimezone, getLocalDateWithoutTimezone, momentToTimestampSeconds } from "../../utils/date.js";
import "react-intl";
function convertInternalFormatToSeconds(dateLocal, dayBoundary = "start") {
  let res = null;
  let value = dateLocal ? moment.utc(getLocalDateWithoutTimezone(moment(dateLocal))) : null;
  if (value) {
    value = dayBoundary === "start" ? value.startOf("day") : value.endOf("day");
    res = momentToTimestampSeconds(value);
  }
  return res;
}
function convertSecondsToInternalFormat(seconds) {
  let result = null;
  if (seconds !== null && seconds !== void 0) {
    const value = timestampSecondsToMoment(seconds === endDateNow ? getNHoursAgoAsSeconds(0) : seconds);
    const date = moment.utc(value);
    result = getUTCDateWithLocalTimezone(date);
  }
  return result;
}
function isDateDisabled(date, availableDateRangeForSelection) {
  const isDataRangeSelectionLimited = availableDateRangeForSelection?.from || availableDateRangeForSelection?.to;
  const isDateInSelectionRange = availableDateRangeForSelection ? (availableDateRangeForSelection.from ? availableDateRangeForSelection.from <= date : true) && (availableDateRangeForSelection.to ? date <= availableDateRangeForSelection.to : true) : true;
  return isDataRangeSelectionLimited && !isDateInSelectionRange;
}
export {
  convertInternalFormatToSeconds,
  convertSecondsToInternalFormat,
  isDateDisabled
};
//# sourceMappingURL=utils.js.map
